import {
	CLOSE_CONNECTION,
	OPEN_CONNECTION,
	SEND_FILES,
	SET_AVAILABILITY,
	SEND_DASHBOARD,
	SEND_PATIENT
} from '../actions/dualScreen';
import { createReducer } from '@reduxjs/toolkit';

const initialState = {
	presentationConnection: null,
	isAvailable: false,
	loading: false,
	dashboardDisplay: false,
	patientDisplay: false
};

const dualScreen = createReducer(initialState, {
	[OPEN_CONNECTION]: (state, action) => {
		if (action.payload?.id !== state.presentationConnection?.id) {
			state.presentationConnection = action.payload;
		}
	},
	[CLOSE_CONNECTION]: (state) => {
		state.presentationConnection = null;
	},
	[SEND_FILES]: (state, action) => {
		if (state.presentationConnection && state.presentationConnection.id)
			state.presentationConnection.send(JSON.stringify({type:'files', role: 'secretary', files: action.payload}));
	},
	[SEND_DASHBOARD]: (state, action) => {
		state.dashboardDisplay = !!action.payload 
		if (state.presentationConnection && state.presentationConnection.id)
			state.presentationConnection.send(JSON.stringify({type:'dashboard', role: 'secretary', stats: action.payload}));
	},
	[SEND_PATIENT]: (state, action) => {
		state.patientDisplay = !!action.payload 
		if (state.presentationConnection && state.presentationConnection.id)
			state.presentationConnection.send(JSON.stringify({type:'patient', role: 'sampler', patient: action.payload}));
	},

	[SET_AVAILABILITY]: (state, action) => {
		state.isAvailable = action.payload;
	},
});

export default dualScreen;
